// 📄 components/Configuracion/aribaDataCenters.ts
// Espejo, SOLO para mostrar/preseleccionar en el formulario, de la tabla
// de Data Centers verificada en functions/providers/ariba.js. La URL
// real de ejecución SIEMPRE se calcula server-side a partir del
// `dataCenter` guardado — estos valores acá nunca se usan para ejecutar
// la llamada, solo para que urlBase/tokenUrl se vean coherentes en la
// pantalla de Configuración (el bug que se corrige con esto: antes
// urlBase se tecleaba a mano y podía no corresponder al Data Center
// elegido).
export interface AribaDataCenterInfo {
  codigo: 'US' | 'EU' | 'CN';
  label: string;
  urlBase: string;
  tokenUrl: string;
  disponible: boolean;
}

export const ARIBA_DATA_CENTERS: AribaDataCenterInfo[] = [
  {
    codigo: 'US',
    label: 'Estados Unidos',
    urlBase: 'https://openapi.ariba.com',
    tokenUrl: 'https://api.ariba.com/v2/oauth/token',
    disponible: true
  },
  {
    codigo: 'EU',
    label: 'Europa',
    urlBase: 'https://eu.openapi.ariba.com',
    tokenUrl: 'https://api-eu.ariba.com/v2/oauth/token',
    disponible: true
  },
  {
    codigo: 'CN',
    label: 'China — host sin confirmar todavía',
    urlBase: '',
    tokenUrl: '',
    disponible: false
  }
];

const ALIAS: Record<string, 'US' | 'EU' | 'CN'> = {
  us: 'US', usa: 'US', 'united states': 'US', 'estados unidos': 'US',
  eu: 'EU', europe: 'EU', europa: 'EU',
  cn: 'CN', china: 'CN'
};

// Datos guardados antes de que este campo fuera un select (texto libre
// tipo "usa"/"eu") no calzan directo contra los códigos de arriba — se
// normalizan acá para no dejar el select en blanco sin necesidad.
export const normalizarAribaDataCenter = (valor: string): 'US' | 'EU' | 'CN' | '' => {
  const clave = (valor || '').trim().toLowerCase();
  return ALIAS[clave] || '';
};
